import HotelRoomSuperRoom from './hotel-room-super-room-component';

import './hotel-room-super-room.scss';

const MODULE_NAME = 'App.hotels.hotel-room-super-room';
const module = angular.module(MODULE_NAME, [])
    .directive(HotelRoomSuperRoom.DIRECTIVE_NAME, HotelRoomSuperRoom);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotel-room/hotel-room-super-room/hotel-room-super-room-module.js